import Vue from 'vue'
import { store } from '@App/Store/Store'
import { meta } from './Meta'

/**
 * Retorna o caminho para um asset (imagem, áudio, etc.) baseado na URL.
 * Essa função existe para encapsular possíveis alterações de rotas quando rodar em outros
 * ambientes ou em infra particular do cliente.
 *
 * @param {string} path
 */
export function asset(path) {
    return route(path)
}

/**
 * Retorna o caminho para uma URL normalizando o prefixo se necessário.
 * Essa função existe para encapsular possíveis alterações de rotas quando rodar em outros
 * ambientes ou em infra particular do cliente.
 *
 * @param {string} path
 */
export function route(path) {
    const appUrlPrefix = meta('app-url-prefix') || ''

    return appUrlPrefix + path
}

export function routeTemplate(template, params = {}) {
    let routeParams = new URLSearchParams(params)
    return route('/templates?template=' + encodeURIComponent(template) + '&' + routeParams.toString())
}

/**
 * Verifica se o usuário tem acesso a ação especificada baseado na configuração do papel.
 *
 * @param {string} key
 * @return {boolean}
 */
export function roleEnabled(key) {
    let user = store.state.usuário
    return user.papel.atributos_extras[key]
}

window.asset = asset
window.route = route
window.routeTemplate = routeTemplate
window.roleEnabled = roleEnabled

Vue.prototype.asset = asset
Vue.prototype.route = route
Vue.prototype.routeTemplate = routeTemplate
Vue.prototype.roleEnabled = roleEnabled
